import React, { Component } from 'react'
import Link from 'gatsby-link'
import { inject, observer } from 'mobx-react'
import uniqBy from 'lodash/uniqBy'
import range from 'lodash/range'
import includes from 'lodash/includes'
import Row from '../Shared/Row'
import Column from '../Shared/Column'
import BioCard from '../BioCard'
import BioTray from '../BioTray'

import { TransitionGroup, Transition } from 'react-transition-group'
import { TimelineMax } from 'gsap'
import Pagination from '../Pagination'


const STAFF_PER_PAGE = 20

@inject('store')
@observer class TeamFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filters:[],
            teamTray: false,
            activeProfile: null,
            activeStaff: props.profiles,
            pages:[],
            currentPage:1
        }
    }

    componentDidMount() {
        this.params = {}
        if (window.location.search) {
            this.params = this.getUrlParams(window.location.search)
            this.prepopulateFilter()
        }
        else this.filter()
        document.addEventListener('keydown', (e) => e.keyCode == 27 ? this.unsetActiveStaff() : null )
        this.row.refs.thisRow.style.position = 'relative'
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, false )
    }

    getUrlParams(search) {
        let hashes = search.slice(search.indexOf('?') + 1).split('&')
        return hashes.reduce( (params, hash) => {
            let [key, val] = hash.split('=')
            return Object.assign(params, {[key]: decodeURIComponent(val)})
        }, {} )
    }

    prepopulateFilter() {
        const { store } = this.props
        // store.activeFilters.activeCountry = this.params.country || ''
        // store.activeFilters.activeYear = this.params.year || ''
        store.activeFilters.teamFilter.activePage = parseInt(this.params.page) || 1
        store.activeFilters.teamFilter.activeDivision = this.params.staff.split('-').join(' ') || ''
        this.setState({ currentPage : store.activeFilters.teamFilter.activePage })
        this.filter()
    }

    handleScroll() {
        let filterOffset = filterWrapper.getBoundingClientRect().top

        if (mobileos) {
            //mobile fixed filter
            if (filterOffset < 76.0) {
                filterWrapper.classList.add('fix')
            }
            else {
                filterWrapper.classList.remove('fix')
            }
        }
        else {
            // desktop fixed filter
            if (filterOffset < 66.0 ) {
                filterWrapper.classList.add('fix')
            }
            else {
                filterWrapper.classList.remove('fix')
            }
        }
    }

    handleStaffSelect(staffDivision) {
        const { store } = this.props

        if (staffDivision == 'Advisory Council') {
            // console.log(this.props)
            window.location.replace('/advisory-council/')
        }
        else {
            this.params.staff = staffDivision.split(' ').join('-').toLowerCase()
            store.activeFilters.teamFilter.activeDivision = staffDivision.toLowerCase()
            this.setUrlParameters()
        }

        this.filter()
    }

    handlePageChange(index) {
        // console.log('index == ', index)
        if (index > 0 && index <= this.state.pages.length) {
            this.params.page = index
            this.lastPage = this.state.currentPage
            this.setUrlParameters()
            let { pageNumberOffset } = this.state
            this.setState({ currentPage: index, pageNumberOffset })
        }
    }

    filter() {
        const { profiles, store } = this.props
        let staff = profiles.filter( profile => {
            if (store.activeFilters.teamFilter.activeDivision == '') {
                const teams = profile.node.team.map( team => team.title )
                // var temp = teams.indexOf(store.activeFilters.activeDivision ) !== -1
                console.log('profile === ', profile.node.name)
                // Do not show Board of Directiors in "All Staff" team filter
                if( !teams.includes('Board of Directors') ) {
                    return true
                } else {
                    // this is the Board of Directors, so filter out Abby to show on "All Staff" view
                    if (profile.node.name == 'Abby Falik') return true
                }
            }
            else if (profile.node.team.length) {
                // console.log(store.activeFilters.activeDivision)
                const teams = profile.node.team.map( team => {
                    //console.log(team.title.replace('-',' ').toLowerCase() )
                    return team.title.split('-').join(' ').toLowerCase()
                })
                if (teams.indexOf(store.activeFilters.teamFilter.activeDivision ) !== -1) {
                    return profile
                }
            }
        })

        // alphabetize by first name
        staff.sort( (a, b) => {
            if(a.node.name < b.node.name) return -1
            if(a.node.name > b.node.name) return 1
            return 0
        })

        const totalPages = Math.ceil(staff.length / STAFF_PER_PAGE)
        const pageNumArray = []
        for (var i=1; i <= totalPages; i++) {
            pageNumArray.push(i)
        }

        this.setState({ activeStaff: staff, pages:pageNumArray })
        this.handlePageChange(1)
    }

    setUrlParameters() {
        var queryString = Object.keys(this.params).map(key => key + '=' + this.params[key]).join('&')
        var newurl = window.location.pathname + '?' + queryString
        window.history.replaceState( { path:newurl }, '', newurl);
    }

    setActiveStaff(profile, e) {
        document.body.parentNode.classList.add('freeze')
        this.setState({ teamTray: true, activeProfile: profile })
    }

    getStaffByPage() {
        let { currentPage, activeStaff } = this.state
        const startIndex = (currentPage - 1) * STAFF_PER_PAGE
        return activeStaff.slice(startIndex, startIndex + STAFF_PER_PAGE)
    }

    unsetActiveStaff() {
        document.body.parentNode.classList.remove('freeze')
        this.setState({ teamTray: false, activeProfile:null })
    }

    componentWillUnmount() {
        this.unsetActiveStaff()
    }

    handleCardEnter(node) {
        const tl = new TimelineMax()
        tl.set(node, { css: { position:'absolute', top:0 }})
        if (this.lastPage && (this.lastPage < this.state.currentPage)) {
            // slide in left
            tl.fromTo(node, .15, { x:'100%' }, { x:'-=100%' }, .15)
            tl.set(node, { css: { position:'relative' }})
        }
        else {
            // slide in left
            tl.fromTo(node, .15, { x:'-100%' }, { x:'+=100%' }, .15)
            tl.set(node, { css: { position:'relative' }})
        }

    }

    handleCardExit(node) {
        if (this.lastPage && (this.lastPage < this.state.currentPage)) {
            TweenMax.fromTo(node, .15, { x:0 }, { x:'-=100%' })
        }
        else {
            TweenMax.fromTo(node, .15, { x:0 }, { x:'+=100%' })
        }
    }

    render() {
        const { profiles, staffDivision, store } = this.props
        const { activeProfile, activeStaff, pages, currentPage } = this.state
        const pagedStaff = this.getStaffByPage()
        //const thisPages = this.fetchPageNumbers()
        return (
            <span className="fellows-filter" style={{ width: '100%' }}>
                <Row className="no-padding filter-wrapper">
                    <Column width="3" tablet="12">
                        <span ref="filterNav" className="filter-nav">
                            <div>
                                <ul>
                                    <li onClick={ () => this.handleStaffSelect('') } className={ store.activeFilters.teamFilter.activeDivision == '' ? 'active' : '' }>All Staff</li>
                                    { staffDivision.map( (division, index) => (
                                        <li key={ index } className={ store.activeFilters.teamFilter.activeDivision == division.node.title.toLowerCase() ? 'active' : '' } onClick={ () => this.handleStaffSelect(division.node.title) }>{ division.node.title }</li>
                                    ))}
                                    <li><a href="/advisory-council">Advisory Council</a></li>
                                </ul>
                            </div>
                        </span>
                    </Column>
                    <Column width="9" tablet="12">
                        <Row className="no-padding">
                        { pages.length > 1 &&
                            <Pagination pages={ pages }
                                        currentPage={ currentPage }
                                        totalPages={ this.totalPages }
                                        handlePageChange={ page => this.handlePageChange(page) }/>
                        }


                            {/*}<div className="pager">
                                <div><p>Page { currentPage } / { pages.length }</p></div>
                                <div>
                                { thisPages.map( (page, index) => {
                                    if (page == 'LEFT_PAGE') {
                                        return (
                                            <span className="arrow left" key={ index } onClick={ () => this.handlePageChange(currentPage - 1) }>
                                                <div></div>
                                                <div></div>
                                            </span>
                                        )
                                    }
                                    if (page == 'RIGHT_PAGE') {
                                        return (
                                            <span className="arrow right" key={ index } onClick={ () => this.handlePageChange(currentPage + 1) }>
                                                <div></div>
                                                <div></div>
                                            </span>                                        )
                                    }
                                    return (
                                        <span className={ page == currentPage ? 'active' : '' } onClick={ () => this.handlePageChange(page) } key={ index }><p>{ page }</p></span>
                                    )
                                })
                            }
                            </div>

                            </div>
                        */}
                        </Row>
                        <Row className="cards-container no-padding">
                            <TransitionGroup>
                                <Transition key={ store.activeFilters.teamFilter.activeDivision + this.state.currentPage }
                                    timeout={ 300 }
                                    onEnter={ node => this.handleCardEnter(node) }
                                    onExit={ node => this.handleCardExit(node) }>
                                    <Row ref={ el => this.row = el } className="no-padding">
                                        { pagedStaff.map( (staff, index) => (
                                            <Column key={ index } width="3" tablet="6">
                                                <span onClick={ () => this.setActiveStaff(staff.node) }>
                                                    <BioCard data={ staff.node } />
                                                </span>
                                            </Column>
                                        ))}
                                    </Row>
                                </Transition>
                            </TransitionGroup>
                        </Row>
                        { this.state.pages.length > 1  && <div className="filter-nav-arrows">
                            <div style={{ opacity: currentPage > 1 ? 1 : .1 }} onClick={ () => this.handlePageChange(currentPage - 1, true) }>
                                <span></span>
                                <span></span>
                            </div>
                            <div style={{ opacity: currentPage < this.state.pages.length ? 1 : .1 }} onClick={ () => this.handlePageChange(currentPage + 1, true) }>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                        }

                    </Column>
                </Row>

                <BioTray teamTray={ this.state.teamTray }
                         activeProfile={ activeProfile }
                         setActiveFellow={ () => this.setActiveStaff() }
                         unsetActiveFellow={ () => this.unsetActiveStaff() } />

                <div id="member-tray" className={ this.state.teamTray ? 'open' : null }>
                    <div className="close-area" onClick={ () => this.unsetActiveStaff()  } />
                    <div className="container">

                        <div className="container">
                        { this.state.activeProfile &&
                            <div>
                                {
                                    activeProfile.image &&
                                    <img src={ activeProfile.image.resize.src } alt={ activeProfile.name } />
                                }
                                <h1 className="h3">{ activeProfile.name }</h1>
                                <p className="italic">{ activeProfile.title }</p>
                                <hr/>
                                {
                                    activeProfile.bio &&
                                    <p dangerouslySetInnerHTML={{ __html: activeProfile.bio.bio }} />
                                }

                                <div className="close" onClick={ () => this.unsetActiveStaff() }>
                                    <img src="/images/icon-close.svg" alt=""/>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </span>
    )}
}

export default TeamFilter



// WEBPACK FOOTER //
// ./src/components/TeamFilter/index.js